<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to sincerely thank the brilliant publishing team at Austin Macauley Publishing, for all their hard work, commitment, and due diligence. It is with their incredible support I achieved my dream of publishing my first book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?89c2893c